import React from 'react'

const Profile = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M13 10.8332C15.3932 10.8332 17.3333 8.89307 17.3333 6.49984C17.3333 4.1066 15.3932 2.1665 13 2.1665C10.6067 2.1665 8.66663 4.1066 8.66663 6.49984C8.66663 8.89307 10.6067 10.8332 13 10.8332Z" stroke="currentColor" strokeWidth="1.8"></path>
<path d="M21.6666 18.958C21.6666 21.6501 21.6666 23.833 13 23.833C4.33331 23.833 4.33331 21.6501 4.33331 18.958C4.33331 16.2659 8.21381 14.083 13 14.083C17.7861 14.083 21.6666 16.2659 21.6666 18.958Z" opacity="0.5" stroke="currentColor" strokeWidth="1.8"></path>
</svg>
    )
}

export default Profile
